import checkout from "./form";

const {
  formField: {
    taxAgentName,
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contractNumber,
    contractDay,
    dependentUnitName,
    dependentUnitNameTaxId,
    addressWard,
    addressDistrict,
    addressCity,
    activeAddress,
    separateDeclaration,
  },
} = checkout;

const initialValues = {
  [taxAgentName.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [contractNumber.name]: "",
  [contractDay.name]: "",
  [dependentUnitName.name]: "",
  [dependentUnitNameTaxId.name]: "",
  [addressWard.name]: "",
  [addressDistrict.name]: "",
  [addressCity.name]: "",
  [activeAddress.name]: "",
  [separateDeclaration.name]: "",
};

export default initialValues;
